import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import {
	selectAllWorkflowHistoryIds,
	selectWorkflowHistoryById,
} from "reducers/workflowHistorySlice";
import dayjs from "dayjs";
import { CommentOutlined } from "@ant-design/icons";
import utc from "dayjs/plugin/utc";
import { getTimezone } from "utils/common";

dayjs.extend(utc);

const WorkflowHistory = () => {
	return (
		<>
			<h3>Approval History Log</h3>
			<Headers />
			<WhContainer />
		</>
	);
};

const Headers = () => {
	return <></>;
};

const WhContainer = () => {
	const data = useSelector(selectAllWorkflowHistoryIds);
	return data.map((id) => <WhRow key={id} id={id} />);
};

const WhRow = ({ id }) => {
	const { createOn, description, comment } = useSelector((state) =>
		selectWorkflowHistoryById(state, id)
	);

	return (
		<Row
			style={{
				padding: 4,
				borderBottom: "1px solid #ddd",
				maxWidth: 600,
			}}
		>
			<Col span={8}>
				{getTimezone() === "UTC"
					? dayjs.utc(createOn).local().format("DD/MM/YYYY hh:mma")
					: dayjs(createOn).format("DD/MM/YYYY hh:mma")}
			</Col>
			<Col span={16}>{description}</Col>
			{comment && (
				<Col span={16} offset={8} style={{ color: "#555" }}>
					<CommentOutlined />
					&nbsp;
					{comment}
				</Col>
			)}
		</Row>
	);
};

export default WorkflowHistory;
